<script setup lang="ts">
import { RouterLink } from 'vue-router';
withDefaults(
  defineProps<{
    destination: string;
    isExternal?: boolean;
    hierarchy?: 'primary' | 'secondary';
    color?: 'info' | 'warning' | 'danger';
  }>(),
  {
    hierarchy: 'primary',
    color: 'info',
  },
);
</script>

<template>
  <a v-if="isExternal" :href="destination" target="_blank">
    <slot />
  </a>

  <RouterLink
    v-else
    :to="destination"
    class="font-bold hover:underline"
    :class="{
      'text-primary-500': hierarchy === 'secondary',
      'text-accent': hierarchy === 'primary',
      'text-red-500': color === 'danger',
    }"
  >
    <slot />
  </RouterLink>
</template>

<style scoped></style>
